<div class="w-100 bg-white">
  <ng-container *ngTemplateOutlet="customComponent"></ng-container>
</div>
